<mbs-modal class="mbs-rd-enable">
  <ng-container modal-header>
    <span [innerHTML]="'shared:computers.connect.authRequiredCaption' | i18next"></span>
  </ng-container>
  <ng-container modal-body>
    <mbs-alert
      class="mb-0"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'shared:computers.connect.authRequiredText' | i18next }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="handleAuthorize()"
      >{{ 'shared:buttons.authorize' | i18next }}</mbs-button
    >
    <mbs-button
      [type]="'secondary'"
      (click)="baseModal().close()"
      >{{ 'shared:buttons.cancel' | i18next }}</mbs-button
    >
  </ng-container>
</mbs-modal>
